import { render, staticRenderFns } from "./LeisureModuleComponent.vue?vue&type=template&id=7b931436&scoped=true"
import script from "./LeisureModuleComponent.vue?vue&type=script&lang=js"
export * from "./LeisureModuleComponent.vue?vue&type=script&lang=js"
import style0 from "./LeisureModuleComponent.vue?vue&type=style&index=0&id=7b931436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b931436",
  null
  
)

export default component.exports